export default __webpack_public_path__ + "static/media/borderSuccess.06e4ba34.png";